import { mutate } from 'swr';
import axios from 'axios';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { ContactUserTypeEnum, ContactUserTypeLabel } from '../../components/Deals/interfaces';

const path = `/${SERVICES.CONTACT}/assignUser`;
const pathUnassign = `${path}/unassign`;

export const requestChangeAssignedUser = (userId: string, payload: { leadIds: string[]; contactId: string, userType: ContactUserTypeEnum }) => {
  return mutate(path, async() => {
    try {
      await axios.patch(`${path}/${userId}`, payload);
      Notistack.successMessage('Assigned User changed successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestUnAssignUser = (contactId: string, userType: ContactUserTypeEnum, userName: string | undefined) => {
  return mutate(path, async() => {
    try {
      await axios.put(`${pathUnassign}/${contactId}/${userType}`);
      Notistack.successMessage(`${ContactUserTypeLabel[userType]} user ${userName} removed successfully`);
    } catch {
      Notistack.generalError();
    }
  });
};

